import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { GET_USER_WITH_ROLES } from "./gql";

type UseGetUserProps = {
  id?: string;
};

const useGetUser = ({ id }: UseGetUserProps) => {
  const { data, loading, error, refetch } = useQuery(GET_USER_WITH_ROLES, {
    variables: {
      id: id!,
    },
    skip: !id,
  });

  const user = useMemo(
    () =>
      data
        ? {
            ...data.managedUser,
            userRoleBindings: data.managedUser.userRoleBindings || [],
          }
        : undefined,
    [data]
  );

  return { user, loading, error, refetch };
};

export default useGetUser;
